import Overlay from 'editor/components/Overlay';
import React from 'react';

const ECSOverlayContext = React.createContext<Overlay>(new Overlay('', 0));

export default ECSOverlayContext;
